// extracted by mini-css-extract-plugin
export var errorIcon = "_l5-1";
export var nameLogo = "_l5-0";